import React from 'react';

import Contact from './Contact';
import Euro from './Euro';
import Help from './Help';
import Message from './Message';
import Search from './Search';

const Icon = props => {
  // eslint-disable-next-line react/prop-types
  switch (props.name) {
    case 'message':
      return <Message {...props} />;
    case 'help':
      return <Help {...props} />;
    case 'euro':
      return <Euro {...props} />;
    case 'search':
      return <Search {...props} />;
    case 'contact':
      return <Contact {...props} />;
    default:
      return undefined;
  }
};

export default Icon;
